import { useLocale } from '@ecomm/data-hooks'
import type { LineItem } from '@simplisafe/eis-commercetools-carts'
import { getPriceBeforeDiscount } from '@simplisafe/eis-commercetools-carts'
import { formatPrice } from '@simplisafe/eis-commercetools-shared'
import classNames from 'classnames'

export function Item(item: LineItem) {
  const locale = useLocale()

  const { name: name_, quantity, isGift, dynamicPackageMeta } = item

  const name = dynamicPackageMeta?.packageName ?? name_[locale]
  const priceBeforeDiscount = getPriceBeforeDiscount(item, locale) ?? 0
  const formattedPrice = formatPrice(priceBeforeDiscount, locale)

  return (
    <div
      className="flex justify-between py-2 md:justify-start md:py-1"
      data-component="OrderSummaryListItem"
    >
      <div className="flex items-center gap-2">
        <span data-component="quantityText">{quantity}x</span>
        <span className="text-base md:text-lg">{name}</span>
      </div>
      <div className="mx-4 mb-1.5 hidden h-px flex-1 self-end md:flex" />
      <div className="flex flex-row gap-1">
        {isGift ? (
          <span className="text-sale text-right text-base font-normal md:text-lg">
            Free
          </span>
        ) : null}
        <span
          className={classNames('text-base font-normal md:text-lg', {
            'line-through': isGift
          })}
        >
          {formattedPrice}
        </span>
      </div>
    </div>
  )
}
